import { Injectable } from '@angular/core';
import { Logger } from '@service/global.funcs';
@Injectable()
export class SetupRefundReasonService {
    public run() {
        Logger().info('in:SetupRefundReasonService');
    }
}
